module.exports = __webpack_public_path__ + "static/media/google.f42e68fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/google.png
// module id = 105
// module chunks = 0